import { Upload } from 'upload-js'

const upload = Upload({
  apiKey: "public_W142hVXxg6aWu6EYP4dUV6ASPJNX"
})


async function uploadImage(img, setProgress, index, address, type, image_upload_path, driver_name) {

      const safeDriver = String(driver_name)
  .trim()
  .replace(/\s+/g, "_")
  .replace(/[^a-zA-Z0-9_]+/g, ""); // keep it path-safe
  
      const { fileUrl, filePath } = await upload.uploadFile(
        // Required.
        img,
    
      //   // Optional.
        {
      //     onBegin: ({ cancel }) => {
      //       // Call 'cancel()' to stop the upload.
      //     },
          onProgress: ({ bytesSent, bytesTotal }) => {
            setProgress((bytesSent/bytesTotal)*100, index);
          },
          // metadata: { 
          //   driver: driver_name,
          // },
          path: {
            // See "custom file paths" documentation below.
            folderPath: `${image_upload_path}`,
            fileName: `{UTC_DAY}_{UTC_MONTH}_{UTC_YEAR}_{UTC_HOUR}_{UTC_MINUTE}_{UNIQUE_DIGITS_8}_${safeDriver}_{ORIGINAL_FILE_EXT}`
          }
        }
      );
}

export default uploadImage;